import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function Person3Icon(props: IconProps) {
    return <Icon {...props} iconKey={"person_3"}/>
}
